import Image from "next/image";
import Link from "next/link";

const HeaderSitemapHtml = () => {
    return (
        <div className="container">
            <div className="d-flex align-items-center gap-3">
                <Link href="/">
                    <a>
                        <Image
                            src="/logo.svg"
                            height={50}
                            width={50}
                            layout="fixed"
                            alt="Modern Data Stack Logo"
                            style={{ cursor: "pointer" }}
                        />
                    </a>
                </Link>
                <h1 className="m-0 h3 py-5 ">Modern Data Stack - Sitemap</h1>
            </div>
        </div>
    )
}


export default HeaderSitemapHtml;